// extracted by mini-css-extract-plugin
module.exports = {"root":"Main_root__zd-uY","wrap":"Main_wrap__c69Aa","content":"Main_content__2K0G4"};